import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = {
  key: 0,
  class: "cookie-banner"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, { density: "compact" }, {
        prepend: _withCtx(() => [
          _createElementVNode("img", {
            width: "40",
            height: "40",
            class: "mx-2 clickable",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToHome())),
            src: _imports_0
          }),
          (!_ctx.$vuetify.display.xs)
            ? (_openBlock(), _createBlock(_component_v_app_bar_title, {
                key: 0,
                class: "clickable",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToHome()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('appName')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("nav", null, [
            (!_ctx.$vuetify.display.xs)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('menu.home')), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" | ")
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, { to: "/how-to-publish" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.howToPublish')), 1)
              ]),
              _: 1
            }),
            _createTextVNode(" | "),
            _createVNode(_component_router_link, { to: "/contact" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.contact')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { padless: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, { to: "/contact" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.contact')), 1)
              ]),
              _: 1
            }),
            _createTextVNode("  |  "),
            _createVNode(_component_router_link, { to: "/cookiesPolicy" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.cookies')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      ($setup.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('home.bannerCookies')) + " ", 1),
              _createVNode(_component_router_link, { to: "cookiesPolicy" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.bannerCookiesLink')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(".")
            ]),
            _createVNode(_component_v_btn, {
              color: "secondary",
              variant: "text",
              onClick: $setup.okBannerClicked
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('btn.ok')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}